import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import color from '../../theme/color';
import IconSVG from '../Icon/IconSVG';

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
  border: 1px solid #d9dcde !important;
  background-color: transparent !important;
  padding: 8px !important;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
`;

class NavButton extends React.PureComponent {
  render() {
    const { icon, onClick, className } = this.props;

    return (
      <Wrapper onClick={onClick} className={className}>
        {/* <Icon name={icon} color={color.primary} /> */}
        <IconSVG name={icon} />
      </Wrapper>
    );
  }
}

NavButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.oneOf(['chevron-left', 'chevron-right'])
};

export default NavButton;
